// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"06417707","787":"920d0757"}[chunkId] + ".chunk.js";
};